export default "__VITE_PUBLIC_ASSET__b1826ae1__"